import { useEffect } from 'react';
import { useBannerHeight } from '../../../context_providers/banner_context/BannerHeightContext';
import COLORS from '../../../resources/style/Themes';
import Marquee from 'react-fast-marquee';
import { useLoading } from '../../../context_providers/loading_context/LoadingContext';
import { StringKeys } from '../../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import { useEmergencyProvider } from '../../../context_providers/emergency_context/EmergencyProvider';
import { useUserUpdaterProvider } from '../../../context_providers/user_context/UserUpdaterProvider';
import {
  isAdmin,
  isDispatch,
} from '../../routing/UserRoutes/AcceptedRoles';
import { useHistory } from 'react-router-dom';

const EmergencyBanner = () => {
  const { emergencies } = useEmergencyProvider();
  const { updateEmergencyBannerHeight } = useBannerHeight();
  const { transitionComplete } = useLoading();
  const { userRole } = useUserUpdaterProvider();
  // Receipt is a role concern (Admin/Dispatch see emergencies for the org),
  // decoupled from the viewer's own subscription/entitlements.
  const canReceiveEmergencies = isAdmin(userRole) || isDispatch(userRole);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (transitionComplete && canReceiveEmergencies) {
      const hasActiveEmergencies =
        emergencies &&
        Object.values(emergencies).some((emergencyGroup) => {
          return emergencyGroup?.emergency?.isActiveEmergency();
        });
      const newHeight = hasActiveEmergencies ? 30 : 0;
      updateEmergencyBannerHeight(newHeight);
    } else if (!canReceiveEmergencies) {
      updateEmergencyBannerHeight(0);
    }
  }, [
    emergencies,
    updateEmergencyBannerHeight,
    transitionComplete,
    canReceiveEmergencies,
  ]);

  const emergencyMessages = emergencies
    ? Object.values(emergencies)
        .filter((emergencyObj) => {
          return emergencyObj?.emergency?.isActiveEmergency();
        })
        .map((emergencyObj) => {
          const { emergency } = emergencyObj;
          const getDetailedMessage = (incident, firstName, lastName) => {
            switch (incident) {
              case 'SOS Button':
                return t(
                  StringKeys.USER_HAS_REPORTED_AN_EMERGENCY_WITH_THE_SOS_BUTTON,
                  { user: `${firstName} ${lastName}` },
                );
              case 'Dangerous Fall':
                return t(StringKeys.USER_HAS_REPORTED_A_DANGEROUS_FALL, {
                  user: `${firstName} ${lastName}`,
                });
              case 'Head Impact':
                return t(
                  StringKeys.USER_HAS_REPORTED_A_SIGNIFICANT_HEAD_IMPACT,
                  { user: `${firstName} ${lastName}` },
                );
              case 'Arc Flash':
                return t(StringKeys.USER_HAS_REPORTED_AN_ARC_FLASH_INCIDENT, {
                  user: `${firstName} ${lastName}`,
                });
              default:
                return t(StringKeys.USER_HAS_REPORTED_AN_EMERGENCY, {
                  user: `${firstName} ${lastName}`,
                });
            }
          };

          return getDetailedMessage(
            emergency.incident,
            emergency.creator_first_name,
            emergency.creator_last_name,
          );
        })
        .join(' || ')
    : '';

  if (
    !transitionComplete ||
    !canReceiveEmergencies ||
    !emergencies ||
    !Object.values(emergencies).some((emergencyGroup) =>
      emergencyGroup.emergency.isActiveEmergency(),
    )
  ) {
    return null;
  }

  return (
    <div
      style={{
        top: '65px',
        height: '32px',
        textAlign: 'center',
        position: 'fixed',
        color: COLORS.WHITE,
        width: '100%',
        fontWeight: 'bold',
        zIndex: 1000,
        fontSize: '18px',
        background: COLORS.RED,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={() => {
        history.push(`/`);
      }}
    >
      <Marquee gradient={false} style={{ width: '100%', textAlign: 'center' }}>
        {emergencyMessages}
      </Marquee>
    </div>
  );
};

export default EmergencyBanner;
